import { FC } from 'react'
import { ISubsidyBase } from '@/types'
import { SubsidyItemContentLabel } from '@components-v2/molecules/SubsidyItemContentLabel'
import { SubsidyAttributes } from '@components-v2/molecules/SubsidyAttributes'
import { getShortText } from '@/utils'
import styles from './index.module.scss'

type Props = {
  subsidy: ISubsidyBase
}

export const SubsidyCardContent: FC<Props> = ({ subsidy }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <div className={styles.title}>{subsidy?.title}</div>
        <SubsidyItemContentLabel subsidy={subsidy} />
      </div>
      <SubsidyAttributes subsidy={subsidy} />
      <div className={styles.summary}>
        <p>{getShortText(subsidy.summary, 140)}</p>
      </div>
    </div>
  )
}
